import PaginationControls from './pagination-controls';

export default PaginationControls;
